var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletePopupnewicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40.001,
    viewBox: "0 0 40 40.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32610",
    "data-name": "Group 32610",
    transform: "translate(-740 -430)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 20,
    cy: 20,
    rx: 20,
    ry: 20,
    transform: "translate(740 430)",
    fill: "#ffdada"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24202",
    "data-name": "Group 24202",
    transform: "translate(750.601 439.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M228.865,395.468s-.6,10.792-.951,13.937a2.481,2.481,0,0,1-2.614,2.41c-2.892.052-5.788.055-8.679-.006a2.454,2.454,0,0,1-2.537-2.4c-.351-3.173-.95-13.945-.95-13.945",
    transform: "translate(-211.599 -391.348)",
    fill: "none",
    stroke: "#ff4747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M230.549,395.24h-18.8",
    transform: "translate(-211.749 -391.372)",
    fill: "none",
    stroke: "#ff4747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M226.572,395.619a1.827,1.827,0,0,1-1.79-1.468l-.269-1.348a1.419,1.419,0,0,0-1.371-1.052h-4.692a1.419,1.419,0,0,0-1.371,1.052l-.269,1.348a1.827,1.827,0,0,1-1.79,1.468",
    transform: "translate(-211.395 -391.751)",
    fill: "none",
    stroke: "#ff4747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24203",
    "data-name": "Group 24203",
    transform: "translate(7.183 8.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24204",
    "data-name": "Group 24204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M0,0H7.76",
    transform: "rotate(90)",
    fill: "none",
    stroke: "#ff4747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M0,0H7.76",
    transform: "translate(4.434) rotate(90)",
    fill: "none",
    stroke: "#ff4747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePopupnewicon);
export default __webpack_public_path__ + "static/media/deletePopupnewicon.d9d9cf03.svg";
export { ForwardRef as ReactComponent };